import { Component, Inject, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import moment from "moment";
import { RecoveryPlanService } from "src/app/services/recovery-plan.service";
import { MyUtils } from "../../../../services/my-utils.service";
import { ObjectFrom } from "../../../../shared/dynamic-form/models/input-form";
import { DynamicFormServices } from "../../../../shared/dynamic-form/services/dynamic-form.services";

@Component({
  selector: "app-recovery-plan-dialog",
  templateUrl: "./recovery-plan-dialog.component.html",
  styleUrls: ["./recovery-plan-dialog.component.scss"],
})
export class RecoveryPlanDialogComponent implements OnInit {
  inputFormStart: ObjectFrom[];
  inputFormAdditionalInformation: ObjectFrom[];
  inputFormEnd: ObjectFrom[];
  isCreate: boolean = true;
  formGroupStart: FormGroup;
  formGroupEnd: FormGroup;
  groupInfo: any[];
  file?: File;
  fileB64?: string;
  openInfo = false;
  constructor(
    private recoveryPlanService: RecoveryPlanService,
    private dynamicFormService: DynamicFormServices,
    public utils: MyUtils,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      surveyId: string;
      completedDate: string;
      outletId: string;
      isEdit: boolean;
      title: string;
      description: string;
      dateEnd: Date | string;
      attach?: boolean;
      brand?:string;
      region?:string;
      recoveryPlanId?:string;
      closed?: boolean
      additionalInformation: { additionalInfo: string; type: number, usrInsert: string, dtInsert: number}[];
    }
  ) {
    this.inputFormStart = [
      [
        {
          formControlName: "title",
          label: "actionPlan.title",
          placeholder: "title",
          value: data.title,
          validators: {
            required: true,
          },
          template: "input",
          disabled: data.isEdit,
        },
        {
          formControlName: "description",
          label: "description",
          placeholder: "description",
          value: data.description,
          validators: {
            required: true,
          },
          template: "input",
          disabled: data.isEdit,
        },
      ],
    ];

    this.inputFormAdditionalInformation = [
      [
        {
          formControlName: "type",
          label: "typeInfo",
          placeholder: "typeInfo",
          objectSelect: [
            { label: "Comment", value: 0 },
            { label: "Action", value: 1 },
          ],
          value: 0,
          validators: {},
          template: "radioButtonList",
          disabled: false,
        },
      ],
      [
        {
          formControlName: "additionalInfo",
          label: "description",
          placeholder: "description",
          value: undefined,
          validators: {
            required: true,
          },
          template: "textarea",
          disabled: false,
        },
      ],
    ];

    this.inputFormEnd = [
      [
        {
          formControlName: "surveyId",
          label: "surveyId",
          placeholder: "surveyId",
          value: data.surveyId,
          validators: {
            required: true,
          },
          template: "input",
          disabled: true,
        },
        {
          formControlName: "surveyDate",
          label: "surveyDate",
          placeholder: "surveyDate",
          value: this.utils.parseEuropeanDate(data.completedDate),
          validators: {
            required: true,
          },
          template: "dataPicker",
          disabled: true,
        },
      ],
      [
        {
          formControlName: "outletId",
          label: "outletId",
          placeholder: "outletId",
          value: data.outletId,
          validators: {
            required: true,
          },
          template: "input",
          disabled: true,
        },
      ],
      [
        {
          formControlName: "dateStart",
          label: "dateStart",
          placeholder: "dateStart",
          value: new Date(),
          validators: {
            required: true,
          },
          template: "dataPicker",
          disabled: data.isEdit,
        },
        {
          formControlName: "dateEnd",
          label: "dateEnd",
          placeholder: "dateEnd",
          value: data.dateEnd,
          validators: {
            required: true,
          },
          template: "dataPicker",
          disabled:  false,
        },
      ],
    ];
  
    this.formGroupStart = this.dynamicFormService.generateFormGroup(this.inputFormStart);
    this.groupInfo = [];
    this.groupInfo.push(
      this.dynamicFormService.generateFormGroup(this.inputFormAdditionalInformation)
    );

    this.formGroupEnd = this.dynamicFormService.generateFormGroup(this.inputFormEnd);
  }

  returnValue() {
    let data: any = {};
    this.createObject(data, this.formGroupStart);
    let additionalInformation: any = [];
    this.groupInfo.forEach((item) => {
      if (item) {
        additionalInformation.push(item.value);
      }
    });
    data["additionalInformation"] = additionalInformation;
    this.createObject(data, this.formGroupEnd);
    if(this.file) 
     {data.file = this.file }
    return data;
  }

  createObject(data: any, form: FormGroup) {
    Object.keys(form.value).forEach((key) => {
      data[key] = form.value[key];
    });
  }

  isDisable() {
    if (this.data.isEdit) {
      return !(this.groupAdditionalValid() && this.formGroupEnd.valid);
    } else {
      return !(this.formGroupStart.valid && this.groupAdditionalValid() && this.formGroupEnd.valid);
    }
  }

  groupAdditionalValid() {
    return (
      this.groupInfo.filter((item) => item.valid).length ===
      this.groupInfo.filter((item) => item).length
    );
  }

  addInfo() {
    this.groupInfo.push(
      this.dynamicFormService.generateFormGroup(this.inputFormAdditionalInformation)
    );
  }
  removeInfo(i: number) {
    delete this.groupInfo[i];
  }

  ngOnInit(): void {
  }

  incomingfile(event: any) {
    let file = event.target.files[0] as File;
    this.file = event.target.files[0] as File;
  }

  deleteFile() {
    this.file = undefined;
    this.fileB64 = undefined;
  }

  get sizeError() {
    return this.file ? this.file.size > 16 * Math.pow(10, 6) : false;
  }
   parseDate(timestamp: number | string) {
    if (timestamp && timestamp !== "not valid" && timestamp !== "valid") {
      let date = new Date(timestamp);
      return moment(date).format('DD/MM/YYYY, hh:mm');
    } else {
      return "";
    }
  }
  downloadFile() {
      this.recoveryPlanService.getRecoveryPlanAttach(this.data.brand!, this.data.region!, this.data.recoveryPlanId!).subscribe(data => {

    })
  }
}
